export { default } from './Skeleton.js';
